import { useLocalStorage } from '@asgard/ui-common';
import Page from 'components/layout/Page';
import * as S from './HrAsAServicePage.styled';
import { Evaluate } from './sections/evaluate';
import { EvaluateBox } from './sections/evaluate-box';
import { Form } from './sections/form';
import { Help } from './sections/help';
import { Hero } from './sections/hero';
import { HowIs } from './sections/howIs';
import { SuccessCases } from './sections/successCases';
import { SuccessCasesProps } from './sections/successCases/SuccessCases.types';
import { WhatIs } from './sections/whatIs';

export const HrAsAServicePage: React.FC<SuccessCasesProps> = ({ items }) => {
  const [isClosed, setIsClosed] = useLocalStorage('evaluateBoxClosed', false);

  return (
    <Page pageVariant="light" hasScrollTop>
      <S.Root>
        <Hero />
        <WhatIs />
        <Evaluate />
        <Help />
        <HowIs />
        <SuccessCases items={items} />
        <Form />

        {!isClosed && <EvaluateBox onClick={() => setIsClosed(true)} />}
      </S.Root>
    </Page>
  );
};
